<template>
  <transition name="loading-fade">
		<div class="loading-container" v-if="!initStatus">
			<div class="index-loading">
                    <div>在线客服</div>
                <div class="logo">
                </div>
            </div>
        </div>
  </transition>

</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'loading',
  computed: {
    ...mapGetters({
      initStatus: "initStatus"
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Loading.vue